<template>
    <div class="radioGroup">
        <div class="radioGroup_title">
            <svg-sprite style="color: #19BC38" :width="radioKey.w" :height="radioKey.h" :icon-id="radioKey.id"></svg-sprite>
            <span>{{ title }}</span>
        </div>
        <div class="radioGroup_wrapper">
            <label class="radioGroup_label">
                <input @change="onChange(1)" type="radio" :name="'radio-' + uniq" :value="value">
                <span class="radioGroup_radio"></span>
            </label>
            <label class="radioGroup_label">
                <input ref="radio" @change="onChange(-1)" type="radio" :name="'radio-' + uniq" :value="value" checked>
                <span class="radioGroup_radio"></span>
            </label>
            <label class="radioGroup_label">
                <input @change="onChange(0)" type="radio" :name="'radio-' + uniq" :value="value">
                <span class="radioGroup_radio"></span>
            </label>
        </div>
    </div>
</template>

<script>
import getUniqId from "@/helper/getUniqId";

export default {
	name: "RadioGroup",
	props: {
		radioKey: Object,
		isRefresh: String,
		title: String
	},

	watch: {
		isRefresh(val, oldVal) {
			if (val !== oldVal) {
				this.$refs.radio.checked = true;
			}
		}
	},
	data: () => ({
		value: -1,
		uniq: getUniqId()
	}),
	methods: {
		onChange(value) {
			this.$emit('updateRadio', value);
		}
	}
};
</script>

<style scoped lang="scss">
.radioGroup {
    display: flex;
    align-items: center;
    font-size: 0;
    margin-bottom: 15px;

    &:last-child {
        margin-bottom: 0;
    }

    &_title {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #FFFFFF;
        flex-grow: 1;

        span {
            display: inline-block;
            margin-left: 10px;
        }
    }

    &_label {
        cursor: pointer;
        margin: 0 5px;
        font-size: 0;
        display: inline-block;

        [type="radio"] {
            display: none;
        }

        [type="radio"]:checked + span {
            &:after {
                background: #19BC38;
            }

            &:before {
                opacity: 1;
            }
        }
    }

    &_radio {
        position: relative;
        width: 20px;
        height: 20px;
        display: inline-block;

        &:after {
            content: '';
            border-radius: 50%;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            position: absolute;
            border: 1px solid #8F90A6;
        }

        &:before {
            content: '';
            border-radius: 50%;
            width: 8px;
            height: 8px;
            position: absolute;
            background: #fff;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 1;
            opacity: 0;
        }
    }
}
</style>
